export default `
uniform vec2 uResolution;
uniform float uTime;
uniform vec4 uProgress;
const float PI = 3.14159265359;

varying vec3 vNormal;
varying vec3 vViewPosition;

float fresnelEffect(float power){
  return pow((1.0 - clamp(dot(normalize(vNormal), normalize(-vViewPosition)), 0.0, 1.0)), power);
}


void main(){
  vec2 st = (gl_FragCoord.xy / uResolution);
  st -= 0.5;
  st *= (uResolution / min(uResolution.x, uResolution.y));
  float radian = (atan(st.y, st.x) / PI + uTime * 0.25);
  float intensity = fract(radian);
  intensity = smoothstep(mix(0.0, 0.4, uProgress.y), 0.0, intensity) * smoothstep(0.0, 0.05, intensity);

  float fresnel = 1.0 - fresnelEffect(0.7);
  intensity *= smoothstep(0.0, 0.4, fresnel);


  gl_FragColor = vec4(vec3(intensity), 1.0);
}`
